export const prepareUrl = (url: string, params?: string) => {
    if (params) {
        const parmasStr = params.split(',').reduce((acc, arr) => {
            return acc + '&' + arr;
        });
        return url + '?' + parmasStr;
    }
    return url;
};
